import { HOME_LINKS_ID } from '../../../constants/home-links.constants'

const {
  KNOWLEDGE_BUILDERS,
  SOUNDS,
  LIBRARY,
  LIBRARY3,
  VOCAB,
  SONIDOS,
  BIBLIOTECA,
  CAMINOS_BIBLIOTECA,
  TEXAS_ELAR,
  TEXAS_SLAR,
} = HOME_LINKS_ID
const slidesData = {
  [KNOWLEDGE_BUILDERS]: {
    text: 'Knowledge Builders are animated videos that help students get excited and engaged with each knowledge domain.',
    targetID: `#${KNOWLEDGE_BUILDERS}`,
  },
  [SOUNDS]: {
    text: 'The Sound Library contains audio media to support basic phoneme skills.',
    targetID: `#${SOUNDS}`,
  },
  [LIBRARY]: {
    text: 'The Library is an easy way for kids to connect to readers independently. ',
    targetID: `#${LIBRARY}`,
  },
  [LIBRARY3]: {
    text: 'The Library Pilot is an easy way for kids to connect to readers independently. ',
    targetID: `#${LIBRARY3}`,
  },
  [VOCAB]: {
    text: 'The Vocab App gives students a list of daily vocab words, where they can continue working at their most recent level of practice. ',
    targetID: `#${VOCAB}`,
  },
  [SONIDOS]: {
    text: 'The Sonidos library contains audio recordings and image cards of phonemes in Spanish.',
    targetID: `#${SONIDOS}`,
  },
  [BIBLIOTECA]: {
    text: 'The Biblioteca is an easy way for kids to connect to readers independently.',
    targetID: `#${BIBLIOTECA}`,
  },
  [CAMINOS_BIBLIOTECA]: {
    text: 'The Biblioteca contains Spanish versions of the CKLA readers.',
    targetID: `#${CAMINOS_BIBLIOTECA}`,
  },
  [TEXAS_ELAR]: {
    text: 'The Library is an easy way for kids to connect to readers independently. ',
    targetID: `#${TEXAS_ELAR}`,
  },
  [TEXAS_SLAR]: {
    text: 'The Biblioteca is an easy way for kids to connect to readers independently.',
    targetID: `#${TEXAS_SLAR}`,
  },
  programSelector: {
    text: 'Switch between CKLA and Caminos views with program filter buttons.',
    targetID: '#program-selector',
  },
  gradeSelector: {
    text: 'Switch between different grade level views using the grade selector.',
    targetID: '#grade-selector',
  },
  teacherGuide: {
    text: 'New to Amplify Hub? Check out the different tools and how you can use them in your classroom.',
    targetID: '#tab-name-teacher-guide',
  },
  replayTutorial: {
    text: 'View the Hub walkthrough again with the CK2 button.',
    targetID: '#robot-button',
  },
  logoutButton: {
    text: 'Ready to return to Teacher Home? Click the logout button.',
    targetID: '#logout-button',
  },
  intro: {
    text: 'The Amplify Hub is a K-5 digital student experience designed to connect students to the high-quality media and apps available within Amplify programs. Students can access and use these resources independently.',
    targetID: 'body',
    welcomeText: 'Welcome to the Amplify Hub!',
  },
}

export default slidesData
